import { JourneyFragment, StoryInterface } from 'graphql/generated/graphql';

export const isJourneyInProgress = (journey: JourneyFragment) => {
  return (
    journey.stories &&
    journey.stories.stories.some((story: StoryInterface) => {
      return story.alreadyListened;
    }) &&
    !isJourneyCompleted(journey)
  );
};

export const isJourneyCompleted = (journey: JourneyFragment) => {
  return (
    journey.stories &&
    journey.stories.stories.every((story: StoryInterface) => {
      return story.alreadyListened;
    })
  );
};